var path = 'templates/partial/anction-bottom-sheet.html';
var html = "<md-bottom-sheet class=md-grid layout=column ng-cloak> <div layout=row layout-align=\"center center\"> <h4>Since <code>clickOutsideToClose = false</code>, drag down or press ESC to close</h4> </div> <div> <md-list flex layout=row layout-align=\"center center\"> <md-list-item ng-repeat=\"item in items\"> <div> <md-button class=md-grid-item-content ng-click=listItemClick($index)> <md-icon md-svg-src={{item.icon}}></md-icon> <div class=md-grid-text> {{ item.name }} </div> </md-button> </div> </md-list-item> </md-list> </div> </md-bottom-sheet> ";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;


//////////////////
// WEBPACK FOOTER
// ./app/templates/partial/anction-bottom-sheet.html
// module id = 34
// module chunks = 0